export const authUrl = "/auth";

export const rootUrl = process.env.RAILS_ENV === 'staging' ? "https://bizzy-staging.osc-fr1.scalingo.io" : "https://bizzy.ohmydiode.fr";

export default {
  authUrl,
  rootUrl,
  url: rootUrl + '/graphql'
};
